import { render, staticRenderFns } from "./IconRail.vue?vue&type=template&id=0c6fe8c6&scoped=true&"
import script from "./IconRail.vue?vue&type=script&lang=ts&"
export * from "./IconRail.vue?vue&type=script&lang=ts&"
import style0 from "./IconRail.vue?vue&type=style&index=0&id=0c6fe8c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6fe8c6",
  null
  
)

export default component.exports